import Icon from '@ant-design/icons';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  ArrowLeftLanguageIconComponent,
  AssetRedemptionIconComponent,
  MyFNFTSIconComponent,
  MyIAOHistoryIconComponent,
  MyNFTSIconComponent,
  ProfileIconVer2Component,
  SettingIconVer2Component,
  SignOutIconComponent,
} from 'src/assets/icons/IconComponent';
import { PATHS } from 'src/constants/paths';
import { useAppTranslation } from 'src/i18n/hooks';
import './mobile-menu-detail-content.scss';

export interface IWalletDetailContent {
  onClose: () => void;
  onDisconnect: () => void;
}

const AccountContent: React.FC<IWalletDetailContent> = ({ onClose, onDisconnect }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useAppTranslation('common');

  const userTheme = useSelector((state: any) => state.theme);

  const [isOpenDisconnect, setIsOpenDisconnect] = useState<boolean>(false);

  const renderContentWithAuth = () => {
    return (
      <div className={`mobile-menu-detail ${userTheme}`}>
        <div className="mobile-menu-detail__item-wrapper default-item pt-20">
          <div
            className="mobile-menu-detail__item-wrapper__item justify-flex-start"
            onClick={onClose}
          >
            <Icon className="back-icon" component={ArrowLeftLanguageIconComponent} />
            <span>{t('account.account')}</span>
          </div>
        </div>

        <div className="mobile-menu-detail__item-wrapper">
          <a
            className="mobile-menu-detail__item-wrapper__item default-item justify-flex-start"
            href={''}
          >
            <Icon className="item-icon" component={ProfileIconVer2Component} />
            <span>{t('account.profile')}</span>
          </a>
        </div>

        <div className="line"></div>

        <div className="mobile-menu-detail__item-wrapper">
          <a
            className="mobile-menu-detail__item-wrapper__item default-item justify-flex-start"
            href={''}
          >
            <Icon className="item-icon" component={SettingIconVer2Component} />
            <span>{t('account.settings')}</span>
          </a>
        </div>

        <div className="mobile-menu-detail__item-wrapper">
          <div
            className="mobile-menu-detail__item-wrapper__item default-item justify-flex-start"
            onClick={() => setIsOpenDisconnect(true)}
          >
            <Icon className="item-icon" component={SignOutIconComponent} />
            <span>{t('account.disconnect')}</span>
          </div>
        </div>
      </div>
    );
  };

  return <>{renderContentWithAuth()}</>;
};

export default AccountContent;
